import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";

/**
 * This function returns a reusable formated column definition for text data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for text data
 */
export const standardTextColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "enableSorting" | "cell" | "enableColumnFilter" | "minSize" | "meta" | "size" | "enableHiding" | "filterFn">>
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    filterType: "string",
    header: column.header ? column.header.toString() : typeof accessor === "string" ? accessor : "",
    cell: column.cell ? column.cell : info => (
      <Text>
        <>
          {info.getValue()}
        </>
      </Text>
    ),
    enableSorting: column.enableSorting,
    enableColumnFilter: column.enableColumnFilter,
    enableResizing: true,
    minSize: column.minSize,
    enableHiding: column.enableHiding,
    size: column.size,
    meta: {
      style: column.meta?.style ? column.meta?.style : { align: "left" },
      filter: column.meta?.filter ? column.meta?.filter : {
        filterType: "string",
        minLength: 3
      }
    }
  } as DisplayColumnDef<TData>);
};
